(function () {
  function init(section) {
    var track = section.querySelector('.reviews-track');
    var prev = section.querySelector('.reviews-nav--prev');
    var next = section.querySelector('.reviews-nav--next');
    if (!track || !prev || !next) return;

    // Collect originals before cloning
    var originals = Array.prototype.slice.call(track.querySelectorAll('.review-card'));
    if (originals.length === 0) return;

    // Clone once so we can scroll past the end seamlessly
    originals.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', 'true');
      // Remove any motion attrs from clones so they don't fade in
      clone.removeAttribute('data-motion');
      clone.classList.add('is-visible');
      track.appendChild(clone);
    });

    function pageWidth() {
      var firstCard = track.querySelector('.review-card');
      if (!firstCard) return track.clientWidth;
      var cardRect = firstCard.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return cardRect.width + gap;
    }

    function originalWidth() {
      // Sum of original cards including the gap between them
      var step = pageWidth();
      return step * originals.length;
    }

    function wrapIfNeeded() {
      var ow = originalWidth();
      if (track.scrollLeft >= ow) {
        track.scrollLeft = track.scrollLeft - ow;
      } else if (track.scrollLeft < 0) {
        track.scrollLeft = track.scrollLeft + ow;
      }
    }

    // After any smooth-scroll animation ends, snap back into the original range
    var wrapTimer = null;
    function scheduleWrap() {
      if (wrapTimer) clearTimeout(wrapTimer);
      wrapTimer = setTimeout(wrapIfNeeded, 450);
    }

    prev.addEventListener('click', function () {
      // If we're at start, instantly shift forward by one set so the smooth scroll has room
      if (track.scrollLeft <= 0) {
        track.scrollLeft = originalWidth();
      }
      track.scrollBy({ left: -pageWidth(), behavior: 'smooth' });
      scheduleWrap();
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: pageWidth(), behavior: 'smooth' });
      scheduleWrap();
    });

    // Also wrap silently after touch/trackpad scrolls settle
    var scrollIdleTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollIdleTimer) clearTimeout(scrollIdleTimer);
      scrollIdleTimer = setTimeout(wrapIfNeeded, 180);
    }, { passive: true });

    window.addEventListener('resize', wrapIfNeeded);
  }

  function boot() {
    document.querySelectorAll('.section-reviews').forEach(function (el) {
      if (el.__reviewsReady) return;
      el.__reviewsReady = true;
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
